import * as React from 'react'
import {Link} from 'react-router-dom'
import { connect } from 'react-redux'
import {Button, TYPES} from './../components/shared/button'
import logo from './../images/logo.png'
import './../styles/landing/landing.css'

class Landing extends React.Component {

  componentDidMount() {
    if(this.props.auth.isAuthenticated) {
      this.props.history.push('/visits')
    }
  }

  mailTo = (str) => {
    window.location.href=`mailto: tanner@baywatchtech.com?subject=${str}`
  }

  render () {
    return (
      <div className='landing-container'>
        <div className='landing-header'>
          <img src={logo} alt='BayWatch Technologies'/>
          <div className='button-container'>
            <Button
              text='Get Demo Account'
              type='getDemo'
              onClick={() => this.mailTo('Get Demo Account')}
              buttonType={TYPES.DEFAULT}
            />
            <Link to={'/login'}>
              <Button
                text='Login'
                type='landing'
                buttonType={TYPES.DEFAULT}
              />
            </Link>
          </div>
        </div>
        <div className='landing-content-container'>
          <div className='landing-text'>
            <h1>
              SAVING DEALERSHIPS THOUSANDS IN FRAUD CLAIMS AND ADMIN HEADACHES
            </h1>
            <p>
              Handling photos, walk-arounds, and vehicle check is time consuming and often misses the very damage
              it is meant to discover. Baywatch automatically records the full exterior of every vehicle that passes
              through the camera system as it arrives at your business
            </p>
            <Button
              text='Get More Info'
              type='landing'
              onClick={() => this.mailTo('Get More Info')}
              buttonType={TYPES.DEFAULT}
            />
          </div>
          <div className='landing-video'>
            <iframe
              title='Product Tour'
              src='https://www.youtube.com/embed/EF9Ml5L-m40'
              width='100%'
              height='100%'
              frameBorder='0'>
            </iframe>
          </div>
        </div>
        <div className="landing-footer-container">
          <div className="landing-footer-spacer">
          </div>
          <div className="landing-footer-content">
            <div className="landing-footer-info">
              Baywatch Holdings, 2701 N Thanksgiving Way Ste 100, Lehi, UT 84117
            </div>
            <div className="landing-footer-info">
              (435) 890-9181
            </div>
            <div className="landing-footer-info">
              © 2019 Baywatch Holdings
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect( mapStateToProps )( Landing )



// WEBPACK FOOTER //
// ./src/pages/landing.js